export const Collections = {
  users: {
    _path: 'users',
  },
  services: {
    _path: 'services',
    favorites: 'favorites',
  },
  locations: {
    _path: 'locations'
  },
  orders: {
    _path: 'orders',
  },
  settings: {
    _path: 'settings',
  },
  faqs: {
    _path: 'faqs'
  },
  blog: {
    _path: 'blog',
  },
  reservations: {
    _path: 'reservations',
    messages: 'messages',
  }
};
